/* Lagerstatus section — swaps the visible status row when the theme announces a
   variant change (document CustomEvent 'variant:changed' from product-info.js). */
if (!customElements.get('inventory-status')) {
  customElements.define(
    'inventory-status',
    class InventoryStatus extends HTMLElement {
      connectedCallback() {
        this.onVariantChanged = (event) => {
          const variant = event.detail && event.detail.variant;
          if (!variant || !variant.id) return;
          this.showRow(String(variant.id));
        };
        document.addEventListener('variant:changed', this.onVariantChanged);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:changed', this.onVariantChanged);
      }

      showRow(variantId) {
        this.querySelectorAll('.inventory-status__row').forEach((row) => {
          row.classList.toggle('inventory-status__row--hidden', row.dataset.variantId !== variantId);
        });
      }
    }
  );
}
